/** The first page of Prospects under "All statuses", named once so the list and
 *  the background warm share one cache entry per actor and workspace. Other
 *  filters and later pages are read only when asked for. */

import { OutreachService } from '../../services/OutreachService';
import { currentBackgroundReadScope, forgetBackgroundRead } from '../../services/BackgroundReadCache';
import type { Prospect } from '../../types/outreach';

/** GET /prospects pages at up to 200; 50 matches the row budget every other
 *  outreach list (batches, suppressions) defaults to. */
export const PROSPECTS_PAGE_SIZE = 50;

export interface ProspectPage { prospects: Prospect[]; total: number }

export const allProspectsFirstPageRead = (workspaceId: string) => ({
  name: 'outreach/prospects',
  load: async (): Promise<ProspectPage> => {
    const page = await OutreachService.listProspects(workspaceId, { limit: PROSPECTS_PAGE_SIZE, offset: 0 });
    // Kept for a day on this device, so a row from another workspace is refused rather than stored.
    if (!Array.isArray(page?.prospects) || page.prospects.some(row => row?.workspaceId !== workspaceId)) {
      throw new Error('The prospect page scope could not be confirmed.');
    }
    return page;
  },
});

/** After a prospect is saved, so returning to the list never draws the row as it was. */
export function forgetProspectsFirstPage(workspaceId: string): void {
  const scope = currentBackgroundReadScope(workspaceId);
  if (scope) forgetBackgroundRead(scope, allProspectsFirstPageRead(workspaceId).name);
}
